var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64849 15.4943C8.36764 15.7752 7.98672 15.933 7.58953 15.933C7.19234 15.933 6.81143 15.7752 6.53057 15.4943C6.24972 15.2135 6.09194 14.8326 6.09194 14.4354L6.09194 9.94259L1.59916 9.94259C1.20197 9.94259 0.821051 9.78481 0.540198 9.50396C0.259344 9.22311 0.101562 8.84219 0.101562 8.445C0.101562 8.04781 0.259344 7.66689 0.540198 7.38604C0.821051 7.10519 1.20197 6.94741 1.59916 6.94741L6.09194 6.94741L6.09194 2.45463C6.09194 2.05744 6.24972 1.67652 6.53057 1.39567C6.81143 1.11481 7.19234 0.957032 7.58953 0.957032C7.98672 0.957032 8.36764 1.11481 8.64849 1.39567C8.92934 1.67652 9.08712 2.05744 9.08712 2.45463L9.08712 6.94741L13.5799 6.94741C13.9771 6.94741 14.358 7.10519 14.6389 7.38604C14.9197 7.6669 15.0775 8.04781 15.0775 8.445C15.0775 8.84219 14.9197 9.22311 14.6389 9.50396C14.358 9.78481 13.9771 9.9426 13.5799 9.9426L9.08712 9.94259L9.08712 14.4354C9.08712 14.8326 8.92934 15.2135 8.64849 15.4943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlackIcon);
export default __webpack_public_path__ + "static/media/plusBlackIcon.1356ed8e3da1a86838a4cc6a60d3cdf3.svg";
export { ForwardRef as ReactComponent };